<template>
  <div>
    <DemoAlert />
    <Header />
    <NuxtPage />
    <Footer />
    <!-- Floating Content Studio Button -->
    <ContentStudioFloatingButton />
    <!-- Cookie Consent Banner -->
    <ConsentBanner />
  </div>
</template>

<script setup>
import Header from '~/components/Header.vue'
import Footer from '~/components/Footer.vue'
import ContentStudioFloatingButton from '~/components/ContentStudioFloatingButton.vue'
import DemoAlert from '~/components/DemoAlert.vue'
import ConsentBanner from '~/components/ConsentBanner.vue'

const route = useRoute()
const { trackPageView } = useAnalytics()
const { locale } = useI18n()

// Scroll to top on route change
watch(() => route.path, () => {
  if (process.client) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    // Track page view on route change (for SPA navigation)
    trackPageView()
  }
})

// Track initial page view after hydration
onMounted(() => {
  trackPageView()
})

useHead({
  htmlAttrs: {
    lang: () => locale.value || 'en'
  },
  script: [
    {
      src: 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js',
      defer: true
    }
  ],
  meta: [
    // Additional global meta tags
    { name: 'format-detection', content: 'telephone=no' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'application-name', content: 'ommi.shop' },
    { name: 'apple-mobile-web-app-title', content: 'ommi.shop' },
    { name: 'msapplication-TileImage', content: '/mstile-144x144.png' }
  ]
})
</script>
